import {
  FETCH_LAST_VISIT_LOADING,
  FETCH_LAST_VISIT_SUCCESS,
  FETCH_LAST_VISIT_ERROR,
  SET_COMMENT_LIST_TOP_IN_VIEWPORT,
} from "~/store/action_types";
import Angie from "~/utils/angie.jsx";
import { fetch } from "~/utils/fetch.jsx";

const updateParam = (id, objectType, type, value) => {
  return {
    type,
    id,
    objectType,
    value,
  };
};

export const fetchLastVisitTimestamp = (id, objectType, timestamp) => {
  return updateParam(id, objectType, FETCH_LAST_VISIT_SUCCESS, timestamp);
};

export const setCommentListTopInViewport = (id, objectType, value) => {
  return updateParam(id, objectType, SET_COMMENT_LIST_TOP_IN_VIEWPORT, value);
};

export const fetchObjectLastVisitTimestamp = (objectType, objectId, delay = 0) => {
  const slug = Angie.functions.slug(objectType);
  const url = `${Angie.api_url}/since-last-visit/${slug}/${objectId}?delay=${delay}`;
  return {
    types: [FETCH_LAST_VISIT_LOADING, FETCH_LAST_VISIT_SUCCESS, FETCH_LAST_VISIT_ERROR],
    callAPI: () => fetch({ url: url }),
    payload: {
      id: objectId,
      objectType,
    },
    cache: {
      key: url,
    },
  };
};
